/* eslint-disable */
require('./account')
require('./add')
require('./arrow-down-old')
require('./arrow-down')
require('./arrow-left-old')
require('./arrow-right-old')
require('./back-arrow')
require('./caution')
require('./chat')
require('./check-circle')
require('./check')
require('./chevron-down')
require('./chevron-up')
require('./circle-add')
require('./circle-alert')
require('./circle-loading')
require('./clinical-records')
require('./clock')
require('./close')
require('./copy')
require('./daily-summary')
require('./data')
require('./delete')
require('./delivered-package')
require('./delivery-truck')
require('./dismiss')
require('./dot-separator')
require('./down-arrow')
require('./download')
require('./edit-clear')
require('./edit-empty')
require('./edit-session')
require('./edit')
require('./envelop')
require('./erase')
require('./external-link')
require('./funnel')
require('./hand-hold')
require('./hide-password')
require('./hourglass')
require('./id-card')
require('./ifu')
require('./image')
require('./info')
require('./institution')
require('./leave-session')
require('./legal')
require('./log-out')
require('./lot')
require('./manufacter_white')
require('./manufacter')
require('./manufacture-date')
require('./manufacturer')
require('./md')
require('./member-profile')
require('./message')
require('./no-app')
require('./no-wifi')
require('./notes')
require('./notifications')
require('./onboarding-profile')
require('./order-by-AZ')
require('./order-by-ZA')
require('./overview')
require('./patients-group')
require('./patients')
require('./pen')
require('./phone')
require('./photo-camera')
require('./power-on-off')
require('./prescription-active-past')
require('./prescription-upcoming')
require('./prescriptions')
require('./profile')
require('./progress-changes')
require('./progress')
require('./ref')
require('./referral')
require('./remove')
require('./reorder')
require('./report')
require('./results-charts')
require('./retry')
require('./right-arrow')
require('./search')
require('./security')
require('./send')
require('./settings')
require('./skip-forward')
require('./support-help')
require('./support')
require('./sword_logo')
require('./sword')
require('./thumb-down')
require('./tiny-arrow')
require('./to-do-list')
require('./to-top')
require('./transfer')
require('./udi')
require('./ukca')
require('./up-trend-arrow')
require('./user-manual')
require('./user')
require('./video-camera')
require('./video')
require('./weight')
require('./weights')
